import { ILocation } from '../../location/interfaces/location.interface';
import { ILot } from '../../lot/interfaces/lot.interface';
import { IRfq, IRfqStockLog } from '../../rfq/interfaces/rfq.interface';
import { IUnitOfMeasure } from '../../unit-of-measure/interfaces/unit-of-measure.interface';

import { OptionInterface } from './../../shared/interfaces/common.interface';
import { OrderSalesInterface } from './order-sales.interface';

export interface OrderReturnInterface {
  id :number;
  orderId :number;
  orderNumber :string;
  totalOrderQuantity :number;
  orderTotal :number;
  orderDate :Date;
  createDate :Date;
  orderStatus :string;
  paymentMethod :string;
  amountPaid :number;
  source :string;
  skipInventory :boolean;
  parentSalesOrder :OrderSalesInterface;
  orderItems :OrderReturnItemInterface[];
}

export interface OrderReturnItemInterface {
  id :number;
  productId :number | null;
  rfqId :number | null;
  rfq :IRfq | null;
  kitId :number | null;
  sku :string;
  name :string;
  productDescription :string;
  unitPrice :number;
  quantity :number;
  orderedQuantity :number;
  quantityCancelled :number;
  quantityShipped :number;
  locationId :number | null;
  location :ILocation | null;
  lotId :number | null;
  lot :ILot | null;
  baseUomId :number;
  baseUom :IUnitOfMeasure | null;
  orderedUomId :number;
  orderedUom :IUnitOfMeasure | null;
  rfqStockLog :IRfqStockLog;
}

export interface OrderReturnItemFormInterface {
  id :number;
  salesOrderItemId :number;
  productId :string;
  rfqId :string;
  kitId :string;
  sku :string;
  name :string;
  productDescription :string;
  unitPrice :number;
  baseUnitPrice :number;
  baseQuantity :number;
  quantity :number;
  availableQuantity :number;
  orderedQuantity :number;
  quantityOrdered :number;
  quantityCancelled :number;
  quantityShipped :number;
  quantityReturned :number;
  lotId :number;
  selectedLot :OptionInterface | null;
  locationId :number;
  selectedLocation :OptionInterface | null;
  uomId :number;
  selectedUnitOfMeasure :OptionInterface | null;
  baseUomId :number;
  selectedBaseUnitOfMeasure :OptionInterface | null;
  unitClassId :number;
  itemType :string;
  hasLotTracking :boolean;
}

export interface OrderReturnFormInterface {
  id :number | null;
  salesOrderId :number;
  orderDate :Date;
  restock :boolean;
  customRefundAmount :number;
  restockingFee :number;
  items :OrderReturnItemFormInterface[];
}

export enum OrderReturnCustomItems {
  RESTOCKING_FEE = 'restocking_fee',
  CUSTOM_REFUND_AMOUNT = 'custom_refund_amount',
}
